import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import React from 'react';
import PropTypes from 'prop-types';
import { maritalStatusName, employmentTypeName } from 'enums';
import { wizardSidebar, sidebarCard, sidebarItem, sidebarBorrowerName } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var InfoRow = function InfoRow(_ref) {
  var label = _ref.label,
      value = _ref.value;
  return value ? ___EmotionJSX("div", {
    css: sidebarItem
  }, ___EmotionJSX("span", {
    className: "sidebar-label"
  }, label), ___EmotionJSX("span", {
    className: "sidebar-value"
  }, value)) : null;
};

InfoRow.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any
};

var SectionDivider = function SectionDivider(_ref2) {
  var label = _ref2.label;
  return ___EmotionJSX("div", {
    css: function css(theme) {
      return {
        fontSize: '1rem',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        color: theme.gray400,
        padding: '0.8em 0 0.4em',
        marginTop: '0.6em',
        borderTop: "1px solid ".concat(theme.gray100)
      };
    }
  }, label);
};

SectionDivider.propTypes = {
  label: PropTypes.string
};

var formatCity = function formatCity(city) {
  var _city$type, _city$name;

  return city ? "".concat((_city$type = city === null || city === void 0 ? void 0 : city.type) !== null && _city$type !== void 0 ? _city$type : '', " ").concat((_city$name = city === null || city === void 0 ? void 0 : city.name) !== null && _city$name !== void 0 ? _city$name : '').trim() : null;
};

var WizardSidebar = function WizardSidebar(_ref3) {
  var _borrower$phones, _borrower$id_card_are, _borrower$id_card_mun, _borrower$work_place, _borrower$work_place$, _borrower$work_place2, _borrower$work_place3, _borrower$work_place4, _borrower$work_place5, _borrower$work_place6, _borrower$work_place7, _borrower$work_place8, _credit$currency, _guarantor$phones;

  var borrower = _ref3.borrower,
      guarantor = _ref3.guarantor,
      credit = _ref3.credit,
      activeStep = _ref3.activeStep;
  var hasBorrower = (borrower === null || borrower === void 0 ? void 0 : borrower.first_name) || (borrower === null || borrower === void 0 ? void 0 : borrower.id_number);
  var hasCredit = credit === null || credit === void 0 ? void 0 : credit.id;
  var hasGuarantor = (guarantor === null || guarantor === void 0 ? void 0 : guarantor.first_name) || (guarantor === null || guarantor === void 0 ? void 0 : guarantor.id_number); // Step 1 completed = step 2+ means borrower basic data available
  // Step 2 completed = step 3+ means borrower financial data available
  // Step 3 completed = step 4+ means credit data available

  var completedStep1 = activeStep >= 2;
  var completedStep2 = activeStep >= 3;
  var completedStep3 = activeStep >= 4;
  var borrowerName = [borrower === null || borrower === void 0 ? void 0 : borrower.first_name, borrower === null || borrower === void 0 ? void 0 : borrower.middle_name, borrower === null || borrower === void 0 ? void 0 : borrower.last_name].filter(Boolean).join(' ');
  var guarantorName = [guarantor === null || guarantor === void 0 ? void 0 : guarantor.first_name, guarantor === null || guarantor === void 0 ? void 0 : guarantor.middle_name, guarantor === null || guarantor === void 0 ? void 0 : guarantor.last_name].filter(Boolean).join(' ');
  return ___EmotionJSX("aside", {
    css: wizardSidebar
  }, hasBorrower && ___EmotionJSX("div", {
    css: sidebarCard
  }, ___EmotionJSX("p", {
    className: "sidebar-card-title"
  }, "\u041A\u0440\u0435\u0434\u0438\u0442\u043E\u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B"), borrowerName && ___EmotionJSX("p", {
    css: sidebarBorrowerName
  }, borrowerName), ___EmotionJSX(InfoRow, {
    label: "\u0415\u0413\u041D",
    value: borrower === null || borrower === void 0 ? void 0 : borrower.id_number
  }), ___EmotionJSX(InfoRow, {
    label: "\u0418\u043C\u0435\u0439\u043B",
    value: borrower === null || borrower === void 0 ? void 0 : borrower.email
  }), (borrower === null || borrower === void 0 ? void 0 : (_borrower$phones = borrower.phones) === null || _borrower$phones === void 0 ? void 0 : _borrower$phones.length) > 0 && ___EmotionJSX(InfoRow, {
    label: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
    value: borrower.phones[0]
  }), completedStep1 && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(SectionDivider, {
    label: "\u0410\u0434\u0440\u0435\u0441"
  }), ___EmotionJSX(InfoRow, {
    label: "\u041E\u0431\u043B\u0430\u0441\u0442",
    value: borrower === null || borrower === void 0 ? void 0 : (_borrower$id_card_are = borrower.id_card_area) === null || _borrower$id_card_are === void 0 ? void 0 : _borrower$id_card_are.name
  }), ___EmotionJSX(InfoRow, {
    label: "\u041E\u0431\u0449\u0438\u043D\u0430",
    value: borrower === null || borrower === void 0 ? void 0 : (_borrower$id_card_mun = borrower.id_card_municipality) === null || _borrower$id_card_mun === void 0 ? void 0 : _borrower$id_card_mun.name
  }), ___EmotionJSX(InfoRow, {
    label: "\u0413\u0440\u0430\u0434",
    value: formatCity(borrower === null || borrower === void 0 ? void 0 : borrower.id_card_city)
  })), completedStep2 && (borrower === null || borrower === void 0 ? void 0 : borrower.work_place) && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(SectionDivider, {
    label: "\u041C\u0435\u0441\u0442\u043E\u0440\u0430\u0431\u043E\u0442\u0430"
  }), ___EmotionJSX(InfoRow, {
    label: "\u0424\u0438\u0440\u043C\u0430",
    value: borrower === null || borrower === void 0 ? void 0 : (_borrower$work_place = borrower.work_place) === null || _borrower$work_place === void 0 ? void 0 : (_borrower$work_place$ = _borrower$work_place.company) === null || _borrower$work_place$ === void 0 ? void 0 : _borrower$work_place$.name
  }), ___EmotionJSX(InfoRow, {
    label: "\u0415\u0418\u041A",
    value: borrower === null || borrower === void 0 ? void 0 : (_borrower$work_place2 = borrower.work_place) === null || _borrower$work_place2 === void 0 ? void 0 : (_borrower$work_place3 = _borrower$work_place2.company) === null || _borrower$work_place3 === void 0 ? void 0 : _borrower$work_place3.identifier
  }), ___EmotionJSX(InfoRow, {
    label: "\u0414\u043B\u044A\u0436\u043D\u043E\u0441\u0442",
    value: borrower === null || borrower === void 0 ? void 0 : (_borrower$work_place4 = borrower.work_place) === null || _borrower$work_place4 === void 0 ? void 0 : _borrower$work_place4.position
  }), ((borrower === null || borrower === void 0 ? void 0 : (_borrower$work_place5 = borrower.work_place) === null || _borrower$work_place5 === void 0 ? void 0 : _borrower$work_place5.work_experience_years) || (borrower === null || borrower === void 0 ? void 0 : (_borrower$work_place6 = borrower.work_place) === null || _borrower$work_place6 === void 0 ? void 0 : _borrower$work_place6.work_experience_months)) && ___EmotionJSX(InfoRow, {
    label: "\u041E\u0431\u0449 \u0441\u0442\u0430\u0436",
    value: [(borrower === null || borrower === void 0 ? void 0 : (_borrower$work_place7 = borrower.work_place) === null || _borrower$work_place7 === void 0 ? void 0 : _borrower$work_place7.work_experience_years) && "".concat(borrower.work_place.work_experience_years, " \u0433."), (borrower === null || borrower === void 0 ? void 0 : (_borrower$work_place8 = borrower.work_place) === null || _borrower$work_place8 === void 0 ? void 0 : _borrower$work_place8.work_experience_months) && "".concat(borrower.work_place.work_experience_months, " \u043C.")].filter(Boolean).join(' ')
  })), completedStep2 && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(SectionDivider, {
    label: "\u0414\u043E\u043F\u044A\u043B\u043D\u0438\u0442\u0435\u043B\u043D\u043E"
  }), ___EmotionJSX(InfoRow, {
    label: "\u0422\u0440\u0443\u0434\u043E\u0432\u043E \u043F\u0440\u0430\u0432\u043E\u043E\u0442\u043D.",
    value: employmentTypeName[borrower === null || borrower === void 0 ? void 0 : borrower.employment]
  }), ___EmotionJSX(InfoRow, {
    label: "\u0421\u0435\u043C\u0435\u0439\u043D\u043E \u043F\u043E\u043B\u043E\u0436.",
    value: maritalStatusName[borrower === null || borrower === void 0 ? void 0 : borrower.marital_status]
  }))), hasCredit && completedStep3 && ___EmotionJSX("div", {
    css: sidebarCard
  }, ___EmotionJSX("p", {
    className: "sidebar-card-title"
  }, "\u041A\u0440\u0435\u0434\u0438\u0442"), ___EmotionJSX(InfoRow, {
    label: "\u041D\u043E\u043C\u0435\u0440",
    value: credit === null || credit === void 0 ? void 0 : credit.number
  }), ___EmotionJSX(InfoRow, {
    label: "\u0421\u0443\u043C\u0430",
    value: (credit === null || credit === void 0 ? void 0 : credit.amount) && "".concat(Number(credit.amount).toFixed(2), " ").concat((_credit$currency = credit === null || credit === void 0 ? void 0 : credit.currency) !== null && _credit$currency !== void 0 ? _credit$currency : '')
  }), ___EmotionJSX(InfoRow, {
    label: "\u0421\u0440\u043E\u043A",
    value: (credit === null || credit === void 0 ? void 0 : credit.period) && "".concat(credit.period, " \u043C.")
  }), ___EmotionJSX(InfoRow, {
    label: "\u041B\u0438\u0445\u0432\u0430",
    value: (credit === null || credit === void 0 ? void 0 : credit.interest_rate) && "".concat(credit.interest_rate, "%")
  }), ___EmotionJSX(InfoRow, {
    label: "\u0421\u0442\u0430\u0442\u0443\u0441",
    value: credit === null || credit === void 0 ? void 0 : credit.status_display
  })), hasGuarantor && ___EmotionJSX("div", {
    css: sidebarCard
  }, ___EmotionJSX("p", {
    className: "sidebar-card-title"
  }, "\u041F\u043E\u0440\u044A\u0447\u0438\u0442\u0435\u043B"), guarantorName && ___EmotionJSX("p", {
    css: sidebarBorrowerName
  }, guarantorName), ___EmotionJSX(InfoRow, {
    label: "\u0415\u0413\u041D",
    value: guarantor === null || guarantor === void 0 ? void 0 : guarantor.id_number
  }), (guarantor === null || guarantor === void 0 ? void 0 : (_guarantor$phones = guarantor.phones) === null || _guarantor$phones === void 0 ? void 0 : _guarantor$phones.length) > 0 && ___EmotionJSX(InfoRow, {
    label: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
    value: guarantor.phones[0]
  })), !hasBorrower && !hasCredit && ___EmotionJSX("div", {
    css: sidebarCard
  }, ___EmotionJSX("p", {
    className: "sidebar-card-title"
  }, "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F"), ___EmotionJSX("p", {
    style: {
      fontSize: '1.3rem',
      color: 'inherit',
      opacity: 0.5
    }
  }, "\u0414\u0430\u043D\u043D\u0438\u0442\u0435 \u0437\u0430 \u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u0438 \u043A\u0440\u0435\u0434\u0438\u0442\u0430 \u0449\u0435 \u0441\u0435 \u043F\u043E\u043A\u0430\u0436\u0430\u0442 \u0442\u0443\u043A.")));
};

WizardSidebar.propTypes = {
  borrower: PropTypes.object,
  guarantor: PropTypes.object,
  credit: PropTypes.object,
  activeStep: PropTypes.number
};
export default WizardSidebar;